export function financesSelectors(state) {
  return state.finances;
}